import axios from 'axios';
import { getAccessToken, setAccessToken, clearAccessToken } from './auth';

const api = axios.create({
  baseURL: "https://www.vdlsoft.nl/api/v1/notifications",
  withCredentials: true, // IMPORTANT for refresh cookie
});

// Attach access token automatically
api.interceptors.request.use(config => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-refresh on 401
api.interceptors.response.use(
  response => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const res = await axios.get(
          "https://www.vdlsoft.nl/api/v1/auth/refresh",
          { withCredentials: true }
        );

        const newAccessToken = res.data.accessToken;
        setAccessToken(newAccessToken);

        originalRequest.headers.Authorization =
          `Bearer ${newAccessToken}`;

        return api(originalRequest);

      } catch (refreshError) {
        clearAccessToken();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;